module.exports = __webpack_public_path__ + "fae440a02aa199bcaded904bf7ce4a8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/list/buy-swiper-bg.png
// module id = 1134
// module chunks = 0